module.exports = ":host /deep/ clr-tabs ul {\n  margin-top: -0.4rem; }\n"